<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="section">
<p style="  text-align: center;"><img alt="" src="media/table.PNG" style="width:550px;height:880px;"/></p>
<div class="section level3" id="table-of-contents">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?910a05ac